/**
 * button-line-anim.js
 *
 * Globally wraps every .button--primary label in a two-line sliding track
 * so hovering slides the text up and the ghost copy enters from below.
 *
 * Structure built by JS:
 *   .button--primary
 *     .btn-line-wrap          ← overflow:hidden, 1 line tall
 *       .btn-line-track       ← flex-column, transitions -50% on hover
 *         <span>Label</span>          real text
 *         <span aria-hidden>Label</span>  ghost copy
 *
 * Also handles [data-button-animate-nav] spans (nav button inner label)
 * where the outer <li>.button--primary must keep its <a> tag intact.
 *
 * Skips:
 *  · buttons already processed (data-line-init)
 *  · buttons containing complex markup (icons, spinners, inputs)
 *  · prefers-reduced-motion users
 */

(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  // Tags that indicate complex inner markup — skip these buttons
  var SKIP_TAGS = ['input', 'svg', 'img', 'form'];

  function hasComplexMarkup(el) {
    return SKIP_TAGS.some(function (tag) {
      return el.querySelector(tag);
    });
  }

  function wrapInLineTrack(el) {
    if (el.dataset.lineInit) return;
    el.dataset.lineInit = 'true';

    var text = el.textContent.trim();
    if (!text) return;

    var wrap  = document.createElement('span');
    wrap.className = 'btn-line-wrap';

    var track = document.createElement('span');
    track.className = 'btn-line-track';

    var real  = document.createElement('span');
    real.textContent = text;

    var ghost = document.createElement('span');
    ghost.textContent = text;
    ghost.setAttribute('aria-hidden', 'true');

    track.appendChild(real);
    track.appendChild(ghost);
    wrap.appendChild(track);

    el.innerHTML = '';
    el.appendChild(wrap);
  }

  function initAll(root) {
    var r = root || document;

    // ── Standard .button--primary elements ──────────────────────────────────
    // Skip <li> elements (nav) — those are handled via data-button-animate-nav
    r.querySelectorAll('.button--primary:not([data-line-init])').forEach(function (btn) {
      if (btn.tagName === 'LI') return;           // nav: keep <a> intact
      if (hasComplexMarkup(btn)) return;           // cart / buy buttons etc.
      wrapInLineTrack(btn);
    });

    // ── Nav inner-span targets ───────────────────────────────────────────────
    r.querySelectorAll('[data-button-animate-nav]').forEach(function (el) {
      if (hasComplexMarkup(el)) return;
      wrapInLineTrack(el);
    });
  }

  // Run immediately if DOM is ready, otherwise wait
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  // Shopify theme editor: re-run when sections are added/reloaded
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  }
})();
